import { selectEditOrderId, selectedPositionsAvailable } from '@AMIEWEB/NewOrder/Store/Order.selectors';
import { orderCreationNewActions } from '@AMIEWEB/NewOrder/Store/OrderCreation.actions';
import { selectOrderDetailsUIView } from '@AMIEWEB/Order/Store/Order.selectors';
import { TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export const NumberOfPosition = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    control,
    formState: { errors },
    clearErrors,
    setValue,
  } = useFormContext();
  const positionsAvailable = 'positionsAvailable';
  const positionValue = useSelector(selectedPositionsAvailable);
  const orderId = useSelector(selectEditOrderId);
  const orderDetailsUIView = useSelector(selectOrderDetailsUIView);
  const positionOriginaValue = orderDetailsUIView?.orderDetailsOrginal?.positionsAvailable;
  const { pathname } = useLocation();
  const isEdit = !!orderId || pathname.includes('/edit');

  // Set default value when component mounts
  useEffect(() => {
    setTimeout(() => {
      const defaultValue = isEdit ? positionValue : 1;
      setValue(positionsAvailable, defaultValue, { shouldValidate: false });
    }, 1000);
  }, [isEdit, positionValue, setValue, positionsAvailable]);

  const isNumber = value => {
    return /^[0-9]*$/.test(value);
  };

  const handleOrdePositionChange = inputValue => {
    if (isEdit) {
      dispatch(
        orderCreationNewActions.setExpandDeclineFiles(
          parseInt(inputValue) < positionOriginaValue && parseInt(inputValue) === 0,
        ),
      );
      dispatch(
        orderCreationNewActions.setExpandFileOut(
          parseInt(inputValue) < positionOriginaValue && parseInt(inputValue) >= 0,
        ),
      );
    }
  };

  return (
    <Controller
      control={control}
      name={positionsAvailable}
      rules={{
        required: 'Required',
        min: {
          value: 0,
          message: 'Minimum value is 0',
        },
        validate: value => {
          if (!value || value === '') return 'Required';
          if (!isNumber(value)) return 'Must be a number';
          if (parseInt(value) < 0) return 'Minimum value is 0';
          return true;
        },
      }}
      render={({ field }) => (
        <TextField
          required={true}
          fullWidth
          variant="filled"
          color="primary"
          error={!!errors?.positionsAvailable}
          id="positionsAvailable"
          label={t('order.newOrderCreation.tabs.orderTypeDetail.numberOfPosition')}
          value={field.value}
          onChange={e => {
            const inputValue = e.target.value;
            if (isNumber(inputValue)) {
              clearErrors(positionsAvailable);
              field.onChange(e.target.value);
              handleOrdePositionChange(inputValue);
            }
          }}
          helperText={errors?.positionsAvailable && errors?.positionsAvailable?.message}
          InputProps={{
            style: {
              height: '48px',
            },
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      )}
    />
  );
};
